export default "__VITE_ASSET__CZkzkGUH__"